module.exports = __webpack_public_path__ + "6a913b861fde766f3fb66062464eecd1.svg";